// extracted by mini-css-extract-plugin
export default {"bottomIconDiv":"ToggleAudioButton_bottomIconDiv__YQLJl","bottomIcon":"ToggleAudioButton_bottomIcon__US87G","bottomText":"ToggleAudioButton_bottomText__tKlv-"};